import _objectSpread from "/data/jenkins/workspace/saas-prod_cp-fe-bms-web/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import shuttle from '@/components/Shuttle';
import { getGradeClassList, saveChangeStudent, getStudentListNoPage } from '@data/student';
import { mapActions } from 'vuex';
export default {
  name: 'change-class',
  components: {
    shuttle: shuttle
  },
  data: function data() {
    var generateData = function generateData(_) {
      var data = [];
      var cities = ['上海', '北京', '广州', '深圳', '南京', '西安', '成都'];
      var pinyin = ['shanghai', 'beijing', 'guangzhou', 'shenzhen', 'nanjing', 'xian', 'chengdu'];
      cities.forEach(function (city, index) {
        data.push({
          label: city,
          key: index,
          pinyin: pinyin[index]
        });
      });
      return data;
    };

    return {
      roleList: [],
      shuttleTitle: ['全选', '已选学生列表'],
      holderName: ['请输入学生姓名或简拼', '请输入学生姓名或简拼'],
      ruleForm: {
        changeFromGrade: '',
        //民族
        changeFromClass: '',
        //是否独生子女
        changeToGrade: '',
        //是否住校
        changeToClass: '' //是否住校

      },
      gradeList: [],
      classList1: [],
      classList2: [],
      listRight: [],
      formInline: {},
      data: generateData(),
      value: [],
      filterMethod: function filterMethod(query, item) {
        return item.pinyin.indexOf(query) > -1;
      }
    };
  },
  created: function created() {
    this.getGradeAndClass();
  },
  mounted: function mounted() {//            this.roleChangeFn()
  },
  methods: _objectSpread({}, mapActions('user', {
    setUserAlert: 'setUserAlert'
  }), {
    roleChangeFn: function roleChangeFn(list) {
      this.listRight = list;
    },
    saveInfo: function saveInfo() {
      var _this = this;

      var _that = this;

      if (this.listRight.length <= 0) {
        _that.setUserAlert({
          flag: true,
          type: 'info',
          text: '请选择要转班的学生'
        });

        return;
      }

      if (!this.ruleForm.changeToGrade || !this.ruleForm.changeToClass) {
        _that.setUserAlert({
          flag: true,
          type: 'info',
          text: '请选择要转到哪个年级班级'
        });

        return;
      } // if(this.rightSelection.length >0){//判断是否选中学生


      if (this.ruleForm.changeFromGrade == this.ruleForm.changeToGrade && this.ruleForm.changeFromClass == this.ruleForm.changeToClass) {
        //判断是否转入的是不同班级
        _that.setUserAlert({
          flag: true,
          type: 'info',
          text: '请选择不同的转入转出班级'
        });
      } else {
        var idStr = '';

        for (var i = 0; i < this.listRight.length; i++) {
          idStr += this.listRight[i].id + ',';
        }

        idStr = idStr.substring(0, idStr.length - 1);
        saveChangeStudent({
          classId: this.ruleForm.changeToClass,
          gradeId: this.ruleForm.changeToGrade,
          ids: idStr
        }).then(function (res) {
          _that.setUserAlert({
            flag: true,
            type: 'success',
            text: _this.msg.WARNING_86
          });

          _this.ruleForm = {
            changeFromGrade: '',
            //民族
            changeFromClass: '',
            //是否独生子女
            changeToGrade: '',
            //是否住校
            changeToClass: '' //是否住校

          };
          _this.roleList = [];

          _this.$refs.shuttle.clearRoleCheckList();
        }).catch(function (resp) {
          _that.setUserAlert({
            flag: true,
            type: 'error',
            text: resp.message
          });
        });
      }
    },
    //更改左侧年级搜索框
    changeGrade1: function changeGrade1() {
      var _this2 = this;

      this.roleList = [];
      this.$refs.shuttle.clearRoleCheckList();
      this.listRight = [];
      this.ruleForm.changeFromClass = ''; //清空班级

      this.classList1 = this.gradeList.filter(function (item) {
        return item.id == _this2.ruleForm.changeFromGrade;
      })[0].schoolClassList;
    },
    //更改右侧年级搜索框
    changeGrade2: function changeGrade2() {
      var _this3 = this;

      this.ruleForm.changeToClass = '';
      this.classList2 = this.gradeList.filter(function (item) {
        return item.id == _this3.ruleForm.changeToGrade;
      })[0].schoolClassList;
    },
    //更改左侧班级
    changeClass1: function changeClass1() {
      //获取该年级下的学生
      this.getStudent({
        classId: this.ruleForm.changeFromClass
      });
    },
    getStudent: function getStudent(params) {
      var _this4 = this;

      var _that = this;

      getStudentListNoPage(params).then(function (res) {
        _this4.roleList = res;

        _this4.$refs.shuttle.clearRoleCheckList();

        _this4.listRight = [];
      }).catch(function (resp) {
        _that.setUserAlert({
          flag: true,
          type: 'error',
          text: resp.message
        });
      });
    },
    //获取年级班级列表
    getGradeAndClass: function getGradeAndClass() {
      var _this5 = this;

      var _that = this;

      getGradeClassList().then(function (res) {
        _this5.gradeList = res;
      }).catch(function (resp) {
        _that.setUserAlert({
          flag: true,
          type: 'error',
          text: resp.message
        });
      });
    }
  })
};